import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <path d='M14.079 6.695l-.739-.262a.802.802 0 0 1-.455-1.1l.336-.708a1.386 1.386 0 0 0-1.846-1.846l-.707.337a.802.802 0 0 1-1.1-.456l-.262-.738a1.386 1.386 0 0 0-2.611 0l-.263.738a.802.802 0 0 1-1.1.456l-.707-.337a1.386 1.386 0 0 0-1.846 1.846l.336.708a.802.802 0 0 1-.455 1.1l-.739.263a1.385 1.385 0 0 0 0 2.61l.739.263a.802.802 0 0 1 .455 1.1l-.336.707a1.386 1.386 0 0 0 1.846 1.846l.707-.336a.8.8 0 0 1 1.1.456l.262.737a1.386 1.386 0 0 0 2.612 0l.262-.738a.801.801 0 0 1 1.1-.455l.707.336a1.386 1.386 0 0 0 1.846-1.846l-.336-.708a.802.802 0 0 1 .455-1.1l.739-.262a1.385 1.385 0 0 0 0-2.61zM8 10.791a2.876 2.876 0 0 1-2.59-1.717A2.808 2.808 0 0 1 6.925 5.41a2.84 2.84 0 0 1 3.664 1.517 2.808 2.808 0 0 1-1.517 3.664c-.34.14-.705.208-1.073.2z' />
  </svg>
);
